import axios from '@api';

/**
 * Fetches a jwt service token to be used with independent isc docker services (instant_survey).
 */
export const readApiServiceToken = () => {
  return axios({
    method: 'get',
    url: '/v2/api/tokens/api-service-token',
    withCredentials: true,
  }).then(({ data }) => data?.token);
};

/**
 * Fetches a chat service token for the chat agent UI.
 */
export const readChatToken = () => {
  return axios({
    method: 'get',
    url: '/v2/api/tokens/chat-token',
    withCredentials: true,
  }).then(({ data }) => data?.token);
};
